// src/utils/logout.ts

import apiService from '../services/api';

import { telemetryManager } from '../telemetry/TelemetryManager';
import { MODULES } from '../telemetry/constants/modules';
import { ACTIONS } from '../telemetry/constants/actions';

export async function logoutUser() {

  try {

    telemetryManager.track({
      moduleName: MODULES.AUTHENTICATION,
      submoduleName: 'Logout',
      routePath: '/logout',
      eventType: 'action',
      actionType: ACTIONS.LOGOUT,

      actionLabel:
        'User Logout',

    });

    // TODO/DEPRECATED: flush is deprecated in favor of immediate event-driven telemetry uploading.
    /*
    await telemetryManager.flush();
    */
    telemetryManager.unload();

  } catch (error) {

    console.error(
      'Telemetry unload failed:',
      error
    );

  }

  // Ensure telemetry starts a fresh session ID for the next login
  telemetryManager.resetSession();

  await apiService.logout();

}